import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Promise from 'bluebird';

// Services
import Ticket from 'services/data/ticket';

// Actions
import { alerts } from 'modules/alerts/actions';

// Components
import { AjaxSelectInput } from 'components/forms/form-elements';

// Constants
import { SELECT_PAGE_SIZE, SHORT_HUMAN_DATE_FORMAT } from 'constants';


export default class TicketSelect extends React.Component {
  static propTypes = {
    company: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    agreement: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    customWhere: PropTypes.object
  };

  constructor() {
    super();
    this.getData = this.getData.bind(this);
  }

  getData(term, vals) {
    const { agreement, company, customWhere } = this.props;
    const ids = _.compact(_.concat([], vals));

    const params = {
      where: customWhere || {},
      sort: ['nextTaskDate', 'closedAt DESC', 'description'],
      limit: SELECT_PAGE_SIZE
    };

    if (term) params.where.description = { contains: term };
    if (company) params.where.company = company;
    if (agreement) params.where.or = { agreement, type: { in: ['Business Development', 'Internal'] } };

    return Promise.all([
      Ticket.find(params),
      ids && ids.length ? Ticket.find({ where: { id: { in: ids } } }) : []
    ])
      .then(([search, values]) => _.unionBy(search, values, 'id'))
      .catch(alerts.catchError);
  }

  renderTicketOption(ticket) {
    const formattedClosedDate = moment(ticket.closedAt).format(SHORT_HUMAN_DATE_FORMAT);
    return (
      <span>
        {ticket.description} {ticket.closedAt ? <span className="deemphasize">({formattedClosedDate})</span> : ''}
      </span>
    );
  }

  render() {
    const { agreement, company } = this.props;

    return (
      <AjaxSelectInput
        {..._.omit(this.props, ['company', 'agreement'])}
        labelKey="description"
        valueKey="id"
        triggerUpdate={agreement || company}
        loadOptions={this.getData}
        optionRenderer={this.renderTicketOption}
        groupBy={(options) => _.groupBy(options, (option) => { // eslint-disable-line arrow-body-style
          return (option.status === 'Active') ? 'Open' : option.status;
        })}
      />
    );
  }
}
